import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { createScopedJSONStorage } from '@/lib/browser/scopedStorage';

/**
 * Autosave store for managing autosave enabled/disabled state
 * Persists to localStorage so the preference is remembered across sessions
 */
interface AutosaveState {
  enabled: boolean;
  setEnabled: (enabled: boolean) => void;
}

export const useAutosaveStore = create<AutosaveState>()(
  persist(
    (set) => ({
      enabled: true, // Default to ensabled
      setEnabled: (enabled: boolean) => set({ enabled }),
    }),
    {
      name: 'autosave-preference',
      storage: createScopedJSONStorage(),
    }
  )
);
